<div class="card-inner-padding module-selector">
  <div class="module-buttons">
    <button mat-raised-button color="primary" class="module-button primary-module"
      (click)="goToAutogestion()">
      <span class="button-content">
        <mat-icon class="module-icon">person</mat-icon>
        <span class="button-text">
          <span class="button-title">Autogestión</span>
          <span class="button-subtitle">Portal de empleados</span>
        </span>
      </span>
      <mat-icon class="arrow-icon">arrow_forward</mat-icon>
    </button>

    <button mat-raised-button class="module-button secondary-module"
      (click)="goToAdministracion()" type="button">
      <span class="button-content">
        <mat-icon class="module-icon">admin_panel_settings</mat-icon>
        <span class="button-text">
          <span class="button-title">Administración</span>
          <span class="button-subtitle">Panel de gestión</span>
        </span>
      </span>
      <mat-icon class="arrow-icon">arrow_forward</mat-icon>
    </button>
  </div>
</div>
<mat-progress-bar mode="indeterminate" *ngIf="mostrarProgressBar" class="progress-bar"></mat-progress-bar>
